module.exports = __webpack_public_path__ + "img/paper-plane.0d37f75f.svg";